import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-percentage',
  templateUrl: './input-percentage.component.html',
  styleUrls: ['./input-percentage.component.scss'],
})
export class InputPercentageComponent implements OnInit {
  form: FormGroup;
  @Input() label = '';
  @Input() max = 100;
  @Input() id = '';
  @Input() value: number;
  @Input() error: boolean;
  @Input() errorMessage: string;
  @Output() changeValue = new EventEmitter<number>();

  @Input() set disabled(value: boolean) {
    if (!!this.form) {
      value
        ?  this.form.controls.percentage.disable()
        :  this.form.controls.percentage.enable();
    }
  }
  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      percentage: [
        '',
        [Validators.required, Validators.max(this.max), Validators.min(0)],
      ],
    });
  }

  sendValue() {
    const value = this.getControl().value;
    if (value < 0) {
      this.form.patchValue({ percentage: 0 });
    }
    if (value > this.max) {
      this.form.patchValue({ percentage: this.max });
    }
    this.changeValue.emit(this.getControl().value);
  }

  getControl(): AbstractControl {
    return this.form.get('percentage');
  }
}
